// import { open_proto } from "@/lobby_common/webProto/proto.js";
// import { isGame } from "@/lobby_common/utils/utils.js";
// let open_proto = null;
// export async function loadProto() {
//   if (!open_proto) {
//     const module = await import("@/lobby_common/webProto/proto.js");
//     open_proto =
//     module.open_proto ||
//     module.default?.open_proto ||
//     module.default ||
//     null;
//   }
//   return open_proto;
// }
// loadProto();
let open_proto = null;
let protoPromise = null;

// ✅ 防止重复加载 & 自动等待 proto 加载完毕
export async function loadProto() {
  if (open_proto) return open_proto;
  if (protoPromise) return await protoPromise;

  protoPromise = import("@/lobby_common/webProto/proto.js")
    .then((module) => {
      open_proto =
        module.open_proto ||
        module.default?.open_proto ||
        module.default ||
        null;
      return open_proto;
    })
    .catch((err) => {
      // console.error("❌ proto 加载失败：", err);
      open_proto = null;
      return null;
    });

  return await protoPromise;
}

// 预加载（不会阻塞其他逻辑）
loadProto();
import { getAppPromptInfo } from "@/lobby_common/api/resource_gen";
import { freeBetPopConfirm } from "@/lobby_common/api/game_gen";
import {
  divideAccuracy,
  formatLang,
  removeLocalOrderNumbers,
  goJoinEvent,
} from "@/lobby_common/utils/utils";
import {
  kwaiqPost,
  adjustTrackEvent,
  afPostEvent,
  gtagGoogle,
} from "./eventFunction";
let vm = null;
export function sendWsThis(_this) {
  vm = _this;
}
export function sendLoadProto(proto) {
  open_proto = open_proto || proto;
  if (!open_proto) {
    // 预加载（不会阻塞其他逻辑）
    loadProto();
  }
}
let isGamePopup = false;
const wsFun = {
  // 心跳请求
  PingPong(pushParam, msg) {
    // const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    // console.log(data, "websockect 心跳请求");
    // 执行后续的操作
  },

  // 踢用户下线
  KickUser(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "websockect 踢用户下线");
    // 执行后续的操作 退出登录
    vm.$store.dispatch("signOutPs");
  },

  // http异地登录
  OtherLogin(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "websockect http异地登录");
    // 执行后续的操作 退出登录
    vm.$store.commit("setOtherLogin", true);
    vm.$isPopShow({
      show: true,
      views: "IllegalLogin",
      data: { close: true },
    });
  },

  // 系统维护通知
  SystemMaintenanceNotice(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "websockect 系统维护通知");
    // 执行后续的操作 弹出维护弹窗 可关闭
    const arr = data.languages || [];
    const obj = arr.find((v) => v.language === vm.$store.getters.getLang) || {};
    const zone =
      vm.$store.getters?.getPacketConfig?.appConfig?.timeZone || null;
    const text = {
      begin_time_unix: data.beginTimeUnix,
      end_time_unix: data.endTimeUnix,
      content: obj.content,
      zone,
    };
    vm.$isPopShow({
      show: true,
      views: "maintain",
      data: { close: false, text: text, width: "800px" },
    });
  },

  // 系统维护开始
  SystemMaintenance(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "websockect 系统维护开始");
    // 执行后续的操作 退出登录 弹出维护弹窗 不能关闭
    vm.$store.dispatch("signOutPs");
  },

  // 系统维护结束
  SystemMaintenanceEnd(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "websockect 系统维护结束");
    // 执行后续的操作 无操作 维护开始后已经断开websocket连接
    // vm.$store.dispatch("signOutPs");
    // window.location.reload()
  },

  // VIP升降级
  VipUpgrade(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "VIP升降级信息");
    // 执行后续的操作，更新用户信息
    vm.$store.commit("wssSetUserInfo", { level: data.rank });
    // 是否弹窗vip升降级提示公告
    if (data.popSwitch) {
      const lang = vm.$store.getters.getLang || "en";
      const langs = data.vipLang || [];
      const list = langs.filter((item) => item.language === lang);
      if (list.length) {
        list[0].sid = 1;
        const temp = [{ languages: { ...list[0], sid: 1 } }];
        vm.$Bus.$emit("showVipTipModal", {
          ...data,
          languages: { ...list[0], sid: 1 },
        });
      }
    }
    // vip页面更新数据
    vm.$Bus.$emit("changeVipInfo", { vipUpdate: true });
    // huser页面更新数据
    vm.$Bus.$emit("changeVipData", { vipUpdate: true });
  },
  // 用户余额变更
  UserBalanceChange(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "用户余额变更");
    // 执行后续的操作，更新用户钱包信息
    const withdrawMode =
      vm.$store?.getters?.getPacketConfig?.appConfig?.withdrawMode;
    if (withdrawMode === "WITHDRAW_MODE_FREE_GOLD") {
      vm.$Bus.$emit("updateFreeExchange");
    }
    vm.$store.dispatch("getUserCoinsWs", data);

    const changeAmountsObj =
      data.changeAmounts && data.changeAmounts.length
        ? data.changeAmounts[0]
        : {};
    // const chargeArr = [102001, 102002];
    // // 充值已到账：
    // // 102001 入款会员充值
    // // 102002 人工补单
    // if (chargeArr.includes(data.srvType)) {
    //   const amount = changeAmountsObj.amount ? changeAmountsObj.amount : 0;
    //   if (amount <= 0) {
    //     return false;
    //   }
    //   vm.$Bus.$emit("rewardShow", {
    //     amount: amount,
    //     coinCode: data.coinCode,
    //     type: "recharge",
    //   });
    // }
    const rewardArr = [106005];
    // const rewardArr = [103002, 103003, 106004, 106005];
    // // 奖励已到账：（103001注册赠金走其他逻辑）
    // // 103002 首充赠金奖励
    // // 103003 复充赠金奖励
    // // 109002 破产引导奖励：首日赠送、次日赠送、分享好友赠金   已删除，拆分为106004、106005
    // // 106004 破产引导充值奖励
    // // 106005 破产引导分享奖励
    const amount = changeAmountsObj.amount ? changeAmountsObj.amount : 0;
    if (rewardArr.includes(data.srvType) && amount > 0) {
      vm.$Bus.$emit("rewardShow", {
        amount: amount,
        coinCode: data.coinCode,
      });
    }
    // 103028 下载奖励
    if (data.srvType === 103028) {
      const rawardTimer = setTimeout(async () => {
        // 获取下载奖励
        const downloadRewardClaimStatus =
          vm.$store.getters.getDownloadRewardClaimStatus;
        console.log(downloadRewardClaimStatus, "downloadRewardClaimStatus1");
        if (!downloadRewardClaimStatus && amount > 0) {
          // 未领取
          vm.$Bus.$emit("rewardShow", {
            amount: amount,
            coinCode: data.coinCode,
          });
          vm.$store.commit("setDownloadRewardClaimStatus", true);
        }
        clearTimeout(rawardTimer);
      }, 2000);
    }

    const homePageArr = [102001, 102002];
    if (homePageArr.includes(data.srvType)) {
      // 首页模板14-新人充值 数据更新
      vm.$Bus.$emit("updateRechargeDetail");
    }

    setTimeout(() => {
      vm.$store.dispatch("getUserInfo"); // 重新获取用户可用协议
    }, 1500);
  },
  // 完成首次充值-复充
  FirstRecharge(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "完成首次充值-复充");
    vm.$Bus.$emit("rewardShow", {
      amount: Number(data.amount) + Number(data.experienceAmount),
      coinCode: data.userCoinCode,
      chargeAmount: data.money || 0,
      chargeCoinCode: data.coinCode,
      orderNumber: data.orderNumber,
    });
    vm.$Bus.$emit("getWaitRechargeOrderDetailWs");
    vm.$Bus.$emit("updateOrderDetail");
    vm.$Bus.$emit("showFreeExchange", { closeDialog: true });
    if (data.activityType === 26) {
      // 充值转盘 完成了，清除数据
      localStorage.removeItem("chargeWheelData");
      if (data.firstRecharge !== 1) {
        vm.$Bus.$emit("updateRechargeModel", { updateChargeWheel: true });
      }
    }
    if (data.firstRecharge === 1) {
      // 首充
      // 执行后续的操作，更新用户信息
      vm.$store.dispatch("updateUserInfo");
      // 重新获取充值收银台  并且充值活动从首充变为复充
      vm.$Bus.$emit("updateRechargeModel", {
        type: "firstRecharge",
        updateChargeWheel: data.activityType === 26,
      });
      // adjust首充
      adjustTrackEvent({
        eventToken: "firstRecharge",
        revenue: divideAccuracy(data.money, data.accuracy),
        currency: data.coinCode,
      });
      // adjust复充
      adjustTrackEvent({
        eventToken: "recharge",
        revenue: divideAccuracy(data.money, data.accuracy),
        currency: data.coinCode,
      });
      // af充值成功
      afPostEvent({
        event: "purchase",
        amount: divideAccuracy(data.money, data.accuracy),
        currency: data.coinCode,
      });
      // af首充
      afPostEvent({
        event: "firstRecharge",
        jsonobj: {
          amount: divideAccuracy(data.money, data.accuracy),
          currency: data.coinCode,
        },
      });
      // Google首冲
      gtagGoogle("first_purchase");
      // 快手-首充
      kwaiqPost("firstDeposit", {
        value: divideAccuracy(data.money, data.accuracy), // 订单总价
        currency: data.coinCode, // 货币, 目前支持的货币：巴西里亚尔（BRL）、印尼盾（IDR）、美元（USD）
      });
      // 快手-复充 (首充同时上报两个事件)
      kwaiqPost("purchase", {
        value: divideAccuracy(data.money, data.accuracy), // 订单总价
        currency: data.coinCode, // 货币, 目前支持的货币：巴西里亚尔（BRL）、印尼盾（IDR）、美元（USD）
      });
    } else {
      // adjust复充
      adjustTrackEvent({
        eventToken: "recharge",
        revenue: divideAccuracy(data.money, data.accuracy),
        currency: data.coinCode,
      });
      // af充值成功
      afPostEvent({
        event: "purchase",
        amount: divideAccuracy(data.money, data.accuracy),
        currency: data.coinCode,
      });
      // af复充
      afPostEvent({
        event: "complexRecharge",
        jsonobj: {
          amount: divideAccuracy(data.money, data.accuracy),
          currency: data.coinCode,
        },
      });
      // Google复充
      gtagGoogle("purchase");
      // 快手-复充
      kwaiqPost("firstDeposit", {
        value: divideAccuracy(data.money, data.accuracy), // 订单总价
        currency: data.coinCode, // 货币, 目前支持的货币：巴西里亚尔（BRL）、印尼盾（IDR）、美元（USD）
      });
    }
    // 查看本地存储是否有未上报订单与当前订单一致
    removeLocalOrderNumbers(data.orderNumber);
  },

  // 游戏维护
  GameGroupStatusChange(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "游戏维护 游戏组id");
    // 执行后续的操作，更新用户信息
    // 在维护或者即将上线的游戏中
    // if(isGame()) {
    //   const gameGroupSid = vm.$route.params.gid
    //   if(String(gameGroupSid) === String(data?.gameGroupSid)){
    //     vm.$router.push("/home")
    //   }
    // }
    vm.$Bus.$emit("gameGroupMamintai", data);
  },

  // 排行榜结算
  // BetRankActivityRewardSend(pushParam, msg) {
  //   const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
  //   console.log(data, "排行榜结算");
  //   this.$Bus.$emit("rankRewardShow", {
  //     rewardAccount: data.rewardAccount,
  //     reward: data.reward,
  //   });
  // },
  // // 领取新任务
  // ReceiveNewTask(pushParam, msg) {
  //   const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
  //   console.log(data, "领取新任务");
  //   this.$store.commit("taskDot", data.newTaskCount || 0);
  // },
  // 任务完成
  TaskComplete(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "任务完成");
    vm.$store.commit("taskDot", data.unreceivedTaskCount || 0);
    // 更新任务列表
    vm.$Bus.$emit("updateTaskList");
  },
  // 下级助力完成
  SubordinateAssist(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "下级助力完成", vm.$route.path);
    // 在拉新助力活动页面，更新数据
    if (["/reward", "/user/hReward"].includes(vm.$route.path)) {
      vm.$Bus.$emit("updateUserReward", data);
    }
  },
  // 推送用户站内邮件
  UserSiteEmail(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "推送用户站内邮件");
    // 更新红点提示
    // if (data?.sid) {
      vm.$store.dispatch("getPointApi");
    // }
  },
  // 特色模块提现引导是否显示文案
  PushWithdrawGuideText(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    vm.$store.commit("setWithdrawGuideText", data?.showGuideText || false);
  },
  // 红点提示
  RedDot(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    // console.log(data, "红点提示", vm.$route.path);
    vm.$store.dispatch("getPointApi", { data: { ...data, type: 1 } });
    // 奖金列表重新拉取数据
    vm.$Bus.$emit("updateBonusList", "showTip");
  },
  // 游戏弹窗提示
  async gamePopUp(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    if (isGamePopup) {
      return false;
    }
    const lang = vm.$store.getters.getLang || "en";
    let appConfigInfo = {};
    const ref = await getAppPromptInfo({});
    if (ref?.code === 0) {
      appConfigInfo = ref?.data || {};
    }
    const languagesArr = appConfigInfo.languages || [];
    const languagesObj = languagesArr.find((it) => it.language === lang) || {};
    if (data.gamePopupType === 1) {
      isGamePopup = true;
      const getAppConfig = vm.$store.getters.getPacketConfig?.appConfig || {};
      const promptWithdrawAmount = Number(
        getAppConfig.promptWithdrawAmount || 0
      );
      vm.$eventPost("game_hint_popup");
      vm.$confirm(
        languagesObj.promptWithdraw,
        vm.$t("Datalang.Recharge_TIP_tip"),
        {
          confirmButtonText: languagesObj.promptWithdrawButton, // vm.$t("Datalang.home_Go_to1")
          cancelButtonText: vm.$t("Datalang.Recharge_BTM_cancle"),
          showClose: false,
          closeOnClickModal: false,
          customClass: "game-tip-confirm",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(async () => {
          isGamePopup = false;
          vm.$eventPost("game_hint_popup_jump");
          goJoinEvent(appConfigInfo.promptWithdrawJump);
          // vm.$Bus.$emit("showCharge", { show: true });
        })
        .catch(() => {
          isGamePopup = false;
          vm.$eventPost("game_hint_popup_close");
        });
    } else if (data.gamePopupType === 2) {
      isGamePopup = true;
      vm.$eventPost("game_limit_popup");
      vm.$confirm(
        // vm.$t("Datalang.home_Your_balance"),
        languagesObj.promptGameLimit,
        vm.$t("Datalang.Recharge_TIP_tip"),
        {
          confirmButtonText: languagesObj.promptGameLimitButton,
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          customClass: "game-tip-confirm",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(async () => {
          isGamePopup = false;
          vm.$eventPost("game_limit_popup_jump");
          vm.$router.go(-1);
          goJoinEvent(appConfigInfo.promptGameLimitJump);
          // 退出游戏，弹充值弹窗
          // const isSelfStudy = vm.$route.query.brand;
          // if (isSelfStudy === "2") {
          //   vm.$router.push("/home");
          // } else {
          //   vm.$router.go(-1);
          // }
          // setTimeout(() => {
          //   vm.$Bus.$emit("showCharge", { show: true });
          // }, 1000);
        })
        .catch(() => {
          vm.$eventPost("game_limit_popup_close");
        });
    } else if (data.gamePopupType === 3) {  // 免费金币引导提现弹窗
      // 更新游戏中提现浮窗状态
      const freeBetPopConfirmType3 =
        window.sessionStorage.getItem("freeBetPopConfirm") || "false";
      console.log(!freeBetPopConfirmType3, "freeBetPopConfirm");
      if (freeBetPopConfirmType3 === "false") {
        isGamePopup = true;
        // 更新游戏中提现浮窗状态
        vm.$eventPost("game_unlock_withdraw_hint_popup");
        vm.$store.commit("setGameWithdrawFinish", true);
        // vm.$confirm(
        //   languagesObj.freeGoldGuideWithdraw,
        //   vm.$t("Datalang.Recharge_TIP_tip"),
        //   {
        //     confirmButtonText: languagesObj.freeGoldGuideWithdrawButton,
        //     cancelButtonText: vm.$t("Datalang.home_later"),
        //     showClose: true,
        //     closeOnClickModal: false,
        //     customClass: "game-tip-confirm",
        //     dangerouslyUseHTMLString: true,
        //     distinguishCancelAndClose: true,
        //   }
        // )
        //   .then(async () => {
        //     vm.$eventPost("game_unlock_withdraw_hint_popup_jump");
        //     isGamePopup = false;
        //     vm.$router.go(-1);
        //     goJoinEvent(appConfigInfo.promptFreeGoldWithdrawJump);
        //   })
        //   .catch((action) => {
        //     if (action === "cancel") {
        //       // 取消跳转客服
        //       // vm.$eventPost("game_unlock_withdraw_hint_popup_contact_service");
        //       // vm.$Bus.$emit("goKehu");
        //     }
        //     if (action === "close") {
        //       // 关闭
        //       vm.$eventPost("game_unlock_withdraw_hint_popup_close");
        //     }
        //     isGamePopup = false;
        //   });
        
        vm.$isPopShow({
          show: true,
          views: "freeWithdrawTips",
          data: { appConfigInfo, languagesObj },
        });
        isGamePopup = false;

        freeBetPopConfirm({}).then((res) => {
          if (freeBetPopConfirmType3 === "false") {
            window.sessionStorage.setItem("freeBetPopConfirm", true);
          }

          console.log(res, "游戏内免费下注确认收到弹窗返回");
        });
      }
    }
  },
  // 推送周月卡发放消息
  PushWeekMonthCardGrant(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    // 更新周月卡数据
    console.log(data, "购卡成功");
    vm.$Bus.$emit("getWaitRechargeOrderDetailWs");
    vm.$Bus.$emit("updateOrderDetail");
    vm.$Bus.$emit("updateWeekMonthData", data);
  },
  bankrupt(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "==========推送破产标识==========");
    if (data.expireTime) {
      const luckyExpireTime = {
        expireTime: data.expireTime,
      };
      window.localStorage.setItem(
        "luckyExpireTime",
        JSON.stringify(luckyExpireTime)
      );
      // const path = vm.$route.path;
      // // 在游戏内  才弹出破产引导
      // if (
      //   path.includes("/other") ||
      //   path.includes("/games") ||
      //   path.includes("/payGame")
      // ) {
      //   // 破产引导弹窗
      //   vm.$Bus.$emit("luckySubsidyGuide", { expireTime: data.expireTime });
      // }
      vm.$popConfig?.initWinConfig(6);
    } else {
      // 清除破产标记
      window.localStorage.removeItem("luckyExpireTime");
      // 更新收银台
      vm.$Bus.$emit("updateRechargeModel", { type: "bankrupt" });
    }
  },
  // 获取用户头像
  UserAvatar(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "获取用户头像");
    // 执行后续的操作 退出登录 弹出维护弹窗 不能关闭
    vm.$store.dispatch("updateUserInfo");
  },
  // 插入跑马灯消息
  PopMarquee(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    vm.$Bus.$emit("marqueeInsert", data);
  },
  // 收款账户变更
  PushUpdateBankCard(pushParam, msg) {
    console.log("收款账户变更");
    // 执行后续的操作
    vm.$Bus.$emit("rechargeAccountChange");
  },
  // 奖励气泡推送
  BonusBalloon(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "=====奖励气泡推送=====");
    // console.log(
    //   ".reward-tip-message",
    //   document.querySelector(".reward-tip-message")
    // );
    if (document.querySelector(".reward-tip-message")) return;
    if (data.amount && data.amount !== "0") {
      const coinList = vm.$store.getters.getPacketConfig?.coinList || [];
      const coinInfo = coinList.find((i) => i.coinCode === data.coinCode) || {};
      const money = divideAccuracy(
        data.amount,
        coinInfo.accuracy || data.accuracy
      );
      const symbol = coinInfo.symbol || "";
      let str = "";
      if (data.activityType === 17) {
        // 拉新助力
        str = formatLang(vm.$t("Datalang.newly_Congratulations5"), [
          data.username,
          symbol + money,
        ]);
      } else if (data.activityType === 20) {
        // 神秘宝箱
        str = formatLang(vm.$t("Datalang.newly_Congratulations_on"), [
          data.username,
          symbol + money,
        ]);
      }
      vm.$message({
        message: str,
        showClose: true,
        customClass: "reward-tip-message",
        duration: 4000,
      });
    }
  },
  // 推送用户获得奖励(主要针对充值礼包)
  PushUserReward(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    console.log(data, "=====推送用户获得奖励=====");
    vm.$Bus.$emit("getWaitRechargeOrderDetailWs");
    vm.$Bus.$emit("updateOrderDetail");
    vm.$Bus.$emit("showFreeExchange", { closeDialog: true });
    if (data.rewards && data.rewards.length) {
      // 金额奖励
      const moneyObj = data.rewards.find(
        (item) =>
          item.rewardType === 1 ||
          item.rewardType === "ACTIVITY_REWARD_TYPE_MONEY"
      );
      // 免费下注
      const freeBetObj = data.rewards.find(
        (item) =>
          item.rewardType === 2 ||
          item.rewardType === "ACTIVITY_REWARD_TYPE_FREE_BET"
      );
      const extraInfoMoney = moneyObj?.extraInfo
        ? JSON.parse(moneyObj?.extraInfo || "{}")
        : {};
      // const extraInfoFreeBet = freeBetObj?.extraInfo ? JSON.parse(freeBetObj?.extraInfo || "{}") : {};
      const hasEmailMoney = extraInfoMoney.has_email_reward;
      // const hasEmailFreeBet = extraInfoFreeBet.has_email_reward;
      if (moneyObj && freeBetObj) {
        const params = {
          moneyObj: {
            chargeAmount: Number(moneyObj.rewardAmount || 0),
            chargeCoinCode: moneyObj.coinCode,
          },
          rewardType: "ACTIVITY_REWARD_TYPE_MONEY_FREE_BET",
          rewardInfo: freeBetObj.extraInfo || "{}",
        };
        vm.$Bus.$emit("rewardTipsShow", params);
      } else if (moneyObj) {
        vm.$Bus.$emit("rewardShow", {
          type: "recharge",
          btnType: hasEmailMoney ? "email" : "normal",
          // amount: Number(moneyObj.rewardAmount),
          // coinCode: moneyObj.coinCode,
          chargeAmount: Number(moneyObj.rewardAmount || 0),
          chargeCoinCode: moneyObj.coinCode,
        });
      } else if (freeBetObj) {
        const params = {
          rewardType: "ACTIVITY_REWARD_TYPE_FREE_BET",
          rewardInfo: freeBetObj.extraInfo || "{}",
        };
        vm.$Bus.$emit("rewardTipsShow", params);
      }
    }
  },
  // 推送充值任务进度
  PushRechargeTaskProgress(pushParam, msg) {
    const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
    vm.$Bus.$emit("rewardShow", {
      type: "task",
      needRecharge: data.needRecharge || 0,
      coinCode: data.coinCode,
      reward: data.reward || 0,
      accuracy: data.accuracy,
    });
  },
  // 体验彩金上限提示
  // UserLimitExperienceGold(pushParam, msg) {
  //   const data = wsFun.buffDecode(open_proto.websocket[pushParam], msg);
  //   console.log(data, "体验彩金上限提示");
  //   vm.$isPopShow({
  //     show: true,
  //     views: "experienceLimit",
  //   });
  // },

  // ws封装方法 获取推送的协议地址
  getCurPath(msg) {
    if (!open_proto || !open_proto?.websocket) {
      // console.warn("⚠️ open_proto 未加载完成，跳过 buffDecode");
      return {};
    }
    const errMsg = open_proto.websocket.Resp.verify(msg);
    if (errMsg) {
      console.error("is not websocket.Resp object");
      throw Error(errMsg);
    }
    const data = wsFun.getBuffData(msg);
    const replyResult = open_proto.websocket.Resp.decode(data);
    const path = replyResult.path;
    return path;
  },
  // 接收服务器推送的信息的解析 type 协议   msg:返回的msg
  // buffDecode(type, msg) {
  //   const errMsg = open_proto.websocket.Resp.verify(msg);
  //   if (errMsg) {
  //     console.error("is not websocket.Resp object");
  //     throw Error(errMsg);
  //   }
  //   const data = wsFun.getBuffData(msg);
  //   const replyResult = open_proto.websocket.Resp.decode(data);
  //   if (replyResult.body) {
  //     // let useruint8Array = new Uint8Array(replyResult.body);
  //     const userResult = type.decode(replyResult.body);
  //     return userResult;
  //   } else {
  //     return replyResult.header;
  //   }
  // },
  buffDecode(type, msg) {
    if (!open_proto || !open_proto.websocket) {
      // console.warn("⚠️ open_proto 未加载完成，跳过 buffDecode");
      return {};
    }
    try {
      const errMsg = open_proto.websocket.Resp.verify(msg);
      if (errMsg) throw Error(errMsg);
      const data = wsFun.getBuffData(msg);
      const replyResult = open_proto.websocket.Resp.decode(data);
      if (replyResult.body) {
        const userResult = type.decode(replyResult.body);
        return userResult;
        // return type.decode(replyResult.body);
      } else {
        return replyResult.header;
      }
    } catch (e) {
      // console.error("❌ buffDecode解析错误：", e);
      return {};
    }
  },
  // 去除2个字节头
  getBuffData(msg) {
    if (msg) {
      // let pbBuff = msg.slice(2);
      const pbBuff = new Uint8Array(msg);
      return pbBuff;
    } else {
      return null;
    }
  },
};

export default wsFun;
